import { CommonModule } from '@angular/common';
import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { ShoppingCartData, ShoppingCartItem } from '@models/shopping-cart.model';
import { ADDED_FEATURE, REMOVED_FEATURE, UNCHANGED_FEATURE } from '@models/shopping.model';
import { NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { TranslationPipe } from '@pipes/translation/translation.pipe';
import { ModalService } from '@services/modal/modal.service';
import { ViewDetailsComponent } from '@shared-components/view-details/view-details.component';

@Component({
  selector: 'ts-revised-features-readonly',
  templateUrl: './revised-features-readonly.component.html',
  imports: [CommonModule, TranslationPipe]
})
export class RevisedFeaturesReadonlyComponent implements OnChanges {
  @Input() shopping_cart: ShoppingCartData;
  revised_features: Map<string, ShoppingCartItem[]> = new Map<string, ShoppingCartItem[]>([
    ['unchanged_features', []],
    ['added_features', []],
    ['removed_features', []]
  ]);
  disable_sort = (): number => 0;

  constructor(private modal_svc: ModalService) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['shopping_cart'] && changes['shopping_cart'].currentValue) {
      this.revised_features.set('unchanged_features', this.unchangedFeatures);
      this.revised_features.set('added_features', this.addedFeatures);
      this.revised_features.set('removed_features', this.removedFeatures);
    }
  }

  get unchangedFeatures(): ShoppingCartItem[] {
    return this.shopping_cart.shopping_cart_items.filter((f) => f.sub_type === UNCHANGED_FEATURE);
  }

  get addedFeatures(): ShoppingCartItem[] {
    return this.shopping_cart.shopping_cart_items.filter((f) => f.sub_type === ADDED_FEATURE);
  }

  get removedFeatures(): ShoppingCartItem[] {
    return this.shopping_cart.shopping_cart_items.filter((f) => f.sub_type === REMOVED_FEATURE);
  }

  viewDetails(f: ShoppingCartItem): void {
    const modalRef: NgbModalRef = this.modal_svc.open(ViewDetailsComponent, {
      backdrop: 'static',
      centered: true,
      scrollable: true,
      size: 'lg',
      modalDialogClass: 'scrollable-modal-maxheight'
    });
    modalRef.componentInstance.modal_title = f.name;
    modalRef.componentInstance.modal_body = f.description;
  }
}
